export interface DefaultsInterface {
  '@context': string;
}

const Defaults: DefaultsInterface = {
  '@context': 'http://schema.org',
};

export default Defaults;
